import React from 'react';
import styled from 'styled-components';
import { FlexboxGrid, Container, Col, Icon } from 'rsuite';
import StorageImage from '../Image';
import ActionColor from '../ActionColor';

const StyledCard = styled(Container)`
  background-color: #f7f7fa;
  border-radius: 15px;
  margin: 20px;
  padding: 20px;
`;

export default () => (
  <StyledCard>
    <FlexboxGrid.Item
      componentClass={Col}
      colspan={4}
      style={{ display: 'contents' }}
    >
      <StorageImage
        image=""
        alt="photo"
        style={{
          width: 90,
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      />
      <br />
      <p>Unit Name</p>
      <p>Unit Detail - Unit Type</p>
      <p>
        <strong>Status: Good</strong>
      </p>
      <br />
      <div style={{ display: 'flex' }}>
        <Icon icon="wrench" size="lg" /> &nbsp; <ActionColor />
      </div>
      <br />
      <div style={{ display: 'flex' }}>
        <Icon icon="thermometer" size="lg" /> &nbsp;&nbsp;&nbsp; <ActionColor />
      </div>
    </FlexboxGrid.Item>
  </StyledCard>
);
